import React from 'react';
import PropTypes from 'prop-types';
import {withStyles} from '@material-ui/core/styles';
import Chip from '@material-ui/core/Chip';

const styles = theme => ({
    root: {
        display: 'flex',
        justifyContent: 'left',
        flexWrap: 'wrap',
        paddingRight: theme.spacing.unit / 2,
    },
    chip: {
        marginRight: theme.spacing.unit / 2,
    },
});

class ChipsArray extends React.Component {
    handleDelete = chip => () => {
        const chips = [...this.props.chips];
        const chipToDeleteInd = chips.indexOf(chip);
        chips.splice(chipToDeleteInd, 1);
        const updatedLabels = chips.map(chip => chip.label);
        this.props.onDelete && this.props.onDelete(updatedLabels);
    };

    render() {
        const {classes} = this.props;

        return (
            <div className={classes.root}>
                {this.props.chips.map(chip => {
                    return (
                        <Chip
                            key={chip.key}
                            icon={null}
                            label={chip.label}
                            onDelete={this.handleDelete(chip)}
                            className={classes.chip}
                        />
                    );
                })}
                {this.props.children}
            </div>
        );
    }
}

ChipsArray.propTypes = {
    classes: PropTypes.object.isRequired,
    chips: PropTypes.arrayOf(
        PropTypes.shape({
            key: PropTypes.string.isRequired,
            label: PropTypes.string.isRequired,
            onDelete: PropTypes.func
        }).isRequired),
    onDelete: PropTypes.func
};

export default withStyles(styles)(ChipsArray);
